<template>
  <img
    :src="isExistAvatar ? user.avatar : user.default_avatar"
    class="rounded-circle"
    style="height: 60px; width: 60px;"
    @error="isExistAvatar = false" />
</template>

<script>
export default {
  props: ['user'],
  data() {
    return {
      isExistAvatar: true
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
